import { useState, useMemo, useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useToggleArchiveETicketMutation, usePostETicketMutation, usePutETicketMutation, useGetArchivedETicketsMutation, useGetUnarchivedETicketsMutation, } from '@services/product/eTicket/e-ticket.endpoints';
import { ETicketTable } from '@services/product/eTicket/e-ticket.types';
import { ETicketType } from '@services/product/eTicketType/e-ticket-type.types';
import { useGetETicketTypesMutation } from '@services/product/eTicketType/e-ticket-type.endpoints';

export const useETicketsPageVM = () => {
    const [eticketTypes, setETicketTypes] = useState<ETicketType[]>([]);
    const [isArchived, setIsArchived] = useState<boolean>(false);
    const [needReload, setNeedReload] = useState<boolean>();
    const MySwal = withReactContent(Swal);

    const [
        updateETicket,
        {
            isSuccess: isUpdateETicketSuccess
        }
    ] = usePutETicketMutation();


    const [
        createETicket,
        {
            isSuccess: isCreateETicketSuccess
        }
    ] = usePostETicketMutation();

    const [
        getETicketTypes,
        {
            isSuccess: isGetETicketTypesSuccess,
            data: getETicketTypesData
        }
    ] = useGetETicketTypesMutation();


    const [
        toggleArchiveETicket, 
        {
            isSuccess: isToggleArchiveETicketSuccess
        }
    ] = useToggleArchiveETicketMutation();

    useEffect(() => {
        if(isGetETicketTypesSuccess) {
            setETicketTypes(getETicketTypesData?.data || []);
        }
    }, [isGetETicketTypesSuccess]);

    useEffect(() => {
        getETicketTypes(undefined);
    }, []);

    const handleToggleArchiveETicket = (id: number, archive: boolean) => {
        MySwal.fire({
            title: archive ? 'Êtes-vous sûr de vouloir archiver ce e-billet ?' : 'Êtes-vous sûr de vouloir désarchiver ce e-billet ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#5D4B99',
            confirmButtonColor: '#5D4B99',
            confirmButtonText: archive ? 'Archiver' : 'Désarchiver',
            cancelButtonText: 'Annuler',
        }).then((result) => {
            if (result.isConfirmed) {
                toggleArchiveETicket({ id, archived: archive });
            }
        })
    }

    const handleToggleArchiveETickets = (lines: ETicketTable[], archive: boolean) => {
        MySwal.fire({
            title: archive ? 'Êtes-vous sûr de vouloir archiver ces types de e-billets ?' : 'Êtes-vous sûr de vouloir désarchiver ces types de e-billets ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#5D4B99',
            confirmButtonColor: '#5D4B99',
            confirmButtonText: archive ? 'Archiver' : 'Désarchiver',
            cancelButtonText: 'Annuler',
        }).then((result) => {
            if (result.isConfirmed) {
                lines.forEach((line) => {
                    toggleArchiveETicket({ id: line.id, archived: archive });
                });
            }
        })
    }

  

    useEffect(() => {
        if(isCreateETicketSuccess || isUpdateETicketSuccess || isToggleArchiveETicketSuccess) {
            setNeedReload((prev) => !prev);
        }
    }, [isCreateETicketSuccess, isUpdateETicketSuccess, isToggleArchiveETicketSuccess]);


    const mutationHook = useMemo(() => {
        return isArchived ? useGetArchivedETicketsMutation : useGetUnarchivedETicketsMutation;
    }, [isArchived]);

    return {
        mutationHook,
        isArchived,
        needReload,
        setIsArchived,
        createETicket,
        updateETicket,
        eticketTypes,
        MySwal,
        handleToggleArchiveETicket,
        handleToggleArchiveETickets
    };
};
